module.exports = __webpack_public_path__ + "img/email-verified.df737374.svg";